export default __webpack_public_path__ + "static/media/eventPup.86ece1fa.jpg";